import React from 'react';
import { Table } from 'semantic-ui-react';
import FileType from '@constants/fileType';
import FileTypeLabel from '@components/CustomCell/FileTypeLabel';
import getFileType from '@utils/getFileType';
import styles from './FilesTable.module.scss';
import DeleteCell from './DeleteCell';

type Props = {
  file: File;
  index: number;
  onDelete: (index: number, file: File) => void;
};

function UploadedFileRow({ file, index, onDelete }: Props) {
  const fileType = getFileType(file.name);

  return (
    <Table.Row key={index} negative={fileType === FileType.UNKNOWN}>
      <Table.Cell>{file.name}</Table.Cell>
      <Table.Cell className={styles.fileTypeColumn}>
        <FileTypeLabel fileType={fileType} />
      </Table.Cell>
      <DeleteCell index={index} file={file} onDelete={onDelete} />
    </Table.Row>
  );
}

export default UploadedFileRow;
